/* eslint-disable react/jsx-props-no-spreading */
import React from 'react'
import { EditButton, List, TextField } from 'react-admin'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ListTitle from '../../components/ListTitle'
import Datagrid from '../../components/Datagrid/Datagrid'
import Filter from '../../components/Filter/FilterComponents'

const styles = {
    myHeader: {
        '&&:before': {
            content: '" ⇅ "',
        },
    },
    header: {
        display: 'none',
    },
}
const useStyles = makeStyles(styles)

export default function OrganizationList(props) {
    const classes = useStyles(props)
    const { quickSearch } = props
    return (
        <List
            sort={{ field: 'code', order: 'ASC' }}
            filters={<Filter {...props} />}
            {...props}
        >
            <>
                <ListTitle label="Organizations" />
                <Datagrid {...props}>
                    <TextField label="Code" sortable source="code" />
                    <TextField
                        label="Description"
                        sortable
                        source="description"
                    />
                    {quickSearch ? (
                        <EditButton
                            headerClassName={classes.header}
                            basePath="/PY_OrganizationMasterTAB"
                        />
                    ) : (
                        <EditButton basePath="/PY_OrganizationMasterTAB" />
                    )}
                </Datagrid>
            </>
        </List>
    )
}

OrganizationList.defaultProps = {
    quickSearch: false,
}
OrganizationList.propTypes = {
    quickSearch: PropTypes.bool,
}
